import React from "react";
import { createRoot } from "react-dom/client";
import Shield from "./Shield";

// Same contract as the other islands. The payload is already in the document
// and so is a complete, working shield — the server renders the figures, the
// step controls and all twelve moves — so this replaces a page that was
// already a page, and has to re-mount on turbo:load or arriving from the nav
// leaves the shield inert.
export function mount(element) {
  if (!element || element.dataset.mounted === "true") return;
  const payload = JSON.parse(element.dataset.shield);
  element.dataset.mounted = "true";
  createRoot(element).render(<Shield payload={payload} />);
}

function mountAll() {
  document.querySelectorAll("[data-geomancy-shield-root]").forEach(mount);
}

document.addEventListener("DOMContentLoaded", mountAll);
document.addEventListener("turbo:load", mountAll);
